import { PromotersSummaryTable } from './components/PromotersSummaryTable';

const PromotersSummary = () => (
  <PromotersSummaryTable />
);

export {
  PromotersSummary,
};
